import * as React from 'react'
import type { SVGProps } from 'react'
function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 229 244.4"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="c">
        <g>
          <path
            d="M179.2,37.1c-3.4,0-6.7,0.3-10,1c-12.9-24.2-37.8-39.2-65.2-39.2c-38.4,0-70.1,29.3-73.5,67.2C13.3,68.5,0,83.3,0,101.2
			c0,18.9,14.8,34.4,33.6,35.4c0.1,0,0.1,0,0.2,0c1.9,0,3.4-1.5,3.5-3.3c0.1-1.9-1.4-3.6-3.3-3.7c-15.1-0.8-27-13.2-27-28.4
			c0-15.7,12.8-28.5,28.5-28.5c3.9,0,7.8,0.8,11.4,2.4c5,2.2,9.2,5.7,12.2,10.2c1.1,1.6,3.3,2,4.9,0.9c1.6-1.1,2-3.3,0.9-4.9
			c-3.8-5.6-9.1-10-15.3-12.7c-3.8-1.7-7.9-2.6-12-2.9c3.5-33.9,32-59.9,66.5-59.9c24.3,0,46.4,13,58.3,34.1
			c-4.3,1.6-8.5,3.7-12.3,6.5c-7.5,5.4-13.3,12.8-16.9,21.4c-0.7,1.8,0.1,3.8,1.9,4.6c1.8,0.7,3.8-0.1,4.6-1.9
			c3-7.3,8-13.7,14.5-18.4c7.3-5.3,16-8.1,25.1-8.1c23.6,0,42.8,19.2,42.8,42.8s-19.2,42.8-42.8,42.8H96.4c-1.9,0-3.5,1.6-3.5,3.5
			s1.6,3.5,3.5,3.5h82.9c27.4,0,49.8-22.3,49.8-49.8S206.7,37.1,179.2,37.1z"
          />
          <path
            d="M92,153.6c0.5-16-21.1-42.4-23.9-45.8c-0.7-0.8-1.7-1.4-2.8-1.4c-1.1,0-2.1,0.5-2.8,1.4c-3,3.6-24.3,29.8-23.9,45.7
			c0,14.7,12,26.7,26.7,26.7c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C80,180.2,92,168.2,92,153.6z M65.3,173.2
			c-10.9,0-19.7-8.8-19.7-19.8C45.3,143.4,58,125,65.3,115.5c7.4,9.4,20,27.8,19.7,38C85,164.4,76.2,173.2,65.3,173.2z"
          />
          <path
            d="M96.3,191.2c-1.1,0-2.1,0.5-2.8,1.4c-2.2,2.7-17.4,21.4-17.2,33.1c0,11,9,19.9,19.9,19.9c0,0,0,0,0,0c0,0,0,0,0,0
			c0,0,0,0,0,0c11,0,19.9-8.9,19.9-19.9c0.3-11.7-15.1-30.6-17.2-33.1C98.4,191.7,97.4,191.2,96.3,191.2z M109.3,225.6
			c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9c0,0,0-0.1,0-0.1c-0.2-6,7-17.4,12.9-25.2c5.9,7.8,13.1,19.2,12.9,25.2
			C109.3,225.5,109.3,225.5,109.3,225.6z"
          />
        </g>
        <path
          d="M178.6,191.4l-6.3-3.6l3.7-1c0.6-0.2,1.2-0.6,1.5-1.2c0.3-0.6,0.4-1.2,0.2-1.9c-0.2-0.6-0.6-1.2-1.2-1.5
		c-0.6-0.3-1.2-0.4-1.9-0.2l-8.5,2.3l-9-5.1l9-5.2l8.4,2.3c0.6,0.2,1.3,0.1,1.9-0.2c0.6-0.3,1-0.9,1.2-1.5c0.2-0.6,0.1-1.3-0.2-1.9
		c-0.3-0.6-0.9-1-1.5-1.2l-3.7-1l6.3-3.6c0.6-0.3,1-0.9,1.2-1.5c0.2-0.6,0.1-1.3-0.3-1.9c-0.3-0.6-0.9-1-1.5-1.2
		c-0.6-0.2-1.3-0.1-1.9,0.3l-6.3,3.7l1-3.7c0.4-1.3-0.4-2.7-1.8-3c-1.3-0.4-2.7,0.4-3,1.8l-2.3,8.5l-8.9,5.2l0-10.4l6.2-6.2
		c0.5-0.5,0.7-1.1,0.7-1.8c0-0.7-0.3-1.3-0.7-1.8c-1-1-2.5-1-3.5,0l-2.7,2.7l0-7.3c0-0.7-0.3-1.3-0.7-1.8c-0.5-0.5-1.1-0.7-1.8-0.7
		c0,0,0,0,0,0c-1.4,0-2.5,1.1-2.5,2.5l0,7.3l-2.7-2.7c-0.5-0.5-1.1-0.7-1.8-0.7c0,0,0,0,0,0c-0.7,0-1.3,0.3-1.8,0.7
		c-0.5,0.5-0.7,1.1-0.7,1.8c0,0.7,0.3,1.3,0.7,1.8l6.2,6.2l0,10.3l-9-5.2l-2.2-8.4c-0.2-0.6-0.6-1.2-1.2-1.5
		c-0.6-0.3-1.2-0.4-1.9-0.3c-0.6,0.2-1.2,0.6-1.5,1.2c-0.3,0.6-0.4,1.2-0.3,1.9l1,3.7l-6.3-3.6c-0.6-0.3-1.2-0.4-1.9-0.2
		c-0.6,0.2-1.2,0.6-1.5,1.2c-0.3,0.6-0.4,1.2-0.2,1.9c0.2,0.6,0.6,1.2,1.2,1.5l6.3,3.6l-3.7,1c-0.6,0.2-1.2,0.6-1.5,1.2
		c-0.3,0.6-0.4,1.2-0.2,1.9c0.2,0.6,0.6,1.2,1.2,1.5c0.6,0.3,1.2,0.4,1.9,0.2l8.5-2.3l9,5.1l-9,5.2l-8.4-2.3
		c-0.6-0.2-1.3-0.1-1.9,0.2c-0.6,0.3-1,0.9-1.2,1.5c-0.2,0.6-0.1,1.3,0.2,1.9s0.9,1,1.5,1.2l3.7,1l-6.3,3.6
		c-1.2,0.7-1.6,2.2-0.9,3.4c0.3,0.6,0.9,1,1.5,1.2c0.6,0.2,1.3,0.1,1.9-0.3l6.3-3.7l-1,3.7c-0.2,0.6-0.1,1.3,0.3,1.9
		c0.3,0.6,0.9,1,1.5,1.2c0.6,0.2,1.3,0.1,1.9-0.3c0.6-0.3,1-0.9,1.2-1.5l2.3-8.5l8.9-5.2l0,10.4l-6.2,6.2c-1,1-1,2.5,0,3.5
		c1,1,2.5,1,3.5,0l2.7-2.7l0,7.3c0,0.7,0.3,1.3,0.7,1.8c0.5,0.5,1.1,0.7,1.8,0.7c0,0,0,0,0,0c0.7,0,1.3-0.3,1.8-0.7
		c0.5-0.5,0.7-1.1,0.7-1.8l0-7.3l2.7,2.7c0.5,0.5,1.1,0.7,1.8,0.7c0,0,0,0,0,0c0.7,0,1.3-0.3,1.8-0.7c1-1,1-2.5,0-3.5l-6.2-6.2
		l0-10.3l9,5.2l2.2,8.4c0.2,0.6,0.6,1.2,1.2,1.5c0.6,0.3,1.2,0.4,1.9,0.3c1.3-0.4,2.1-1.7,1.8-3l-1-3.7l6.3,3.6
		c1.2,0.7,2.7,0.3,3.4-0.9C180.2,193.6,179.7,192.1,178.6,191.4z"
        />
      </g>
    </svg>
  )
}
export default Icon
